<template>
  <div>
    <hr>
    <DataTable
      :data="medioemps"
      :columns="columnas"
      idField="idMedioEmp"
      :mostrarInfo="false"
      :mostrarVer="false"
      @refresh="getDataTodos"
      @create="abrirModalCrear"
      @edit="row => abrirModalEditar(row.idMedioEmp)"
      @delete="row => deleteMedioEmp(row.idMedioEmp)"
    />

    <!-- Modal -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title" id="exampleModalLabel">
              <i class="fa fa-user-plus"></i> {{ titulo }}
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <form>
            <div class="modal-body">
              <div class="mb-3" v-if="btnEditar">
                <div class="row">
                  <div class="col-2">
                    <label for="idMedioEmp" class="form-label">IdMedioEmp</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="idMedioEmp"
                      v-model="datoMedioEmp.idMedioEmp"
                      disabled
                    />
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idMedioCom" class="form-label">Medio Com</label>
                  </div>
                  <div class="col-10">
                    <select
                      class="form-control"
                      id="idMedioCom"
                      v-model="datoMedioEmp.idMedioCom"
                    >
                      <option
                        v-for="medioCom in medioComs"
                        :value="medioCom.idMedioCom"
                        :key="medioCom.idMedioCom"
                      >
                        {{ medioCom.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="descripcion" class="form-label">Descripción</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="descripcion"
                      v-model="datoMedioEmp.descripcion"
                      style="text-transform:uppercase"
                      required
                    />
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="fechaReg" class="form-label">FechaReg</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="fechaReg"
                      v-model="datoMedioEmp.fechaReg"
                      disabled
                    />
                  </div>
                </div>
              </div>
            </div>
          </form>

          <div class="modal-footer">
            <button
              type="submit"
              class="btn btn-light"
              @click.prevent="guardarMedioEmp"
              v-if="btnCrear"
              title="Guardar"
            >
              <i class="material-icons" style="font-size:32px;color:blue;cursor:pointer">save</i>
            </button>
            <button
              type="submit"
              class="btn btn-light"
              @click.prevent="guardarEditMedioEmp"
              v-if="btnEditar"
              title="Actualizar"
            >
              <i class="material-icons" style="font-size:32px;color:blue;cursor:pointer">update</i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { validarForm } from '@/modules/validacionesForms.js'
import dateFormat from '@/modules/dateFormat.js'
import api from '@/services/api'
import * as $ from 'jquery'
window['$'] = $
window['jQuery'] = $
import swal from 'sweetalert'
import DataTable from '@/components/DataTable.vue'

export default {
  components: { DataTable },

  props: {
    p_idEmpresa: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      medioemps: [],
      datoMedioEmp: {},
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      modalWindow: true,
      medioComs: [],
      // Definición de columnas para DataTable
      columnas: [
        { field: 'medioComNombre', label: 'Medio' },
        { field: 'descripcion',   label: 'Descripción' },
        { field: 'fechaReg',      label: 'Fecha Reg.' },
      ],
    }
  },

  mounted() {
    this.getDataTodos()
    this.fetchMedioComs()
  },

  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date)
    },

    // Carga todos los datos (sin paginación manual, DataTable lo maneja)
    getDataTodos() {
      api.get('/vwmedioemps/idempresa/' + this.p_idEmpresa).then(response => {
        this.medioemps = response.data.reverse()
      })
    },

    validarForm() {
      const requiredFields     = ['idMedioCom', 'descripcion']
      const requiredFieldsText = ['idMedioCom', 'idEmpresa', 'descripcion']
      return validarForm(this.datoMedioEmp, requiredFields, requiredFieldsText)
    },

    async guardarMedioEmp() {
      if (this.validarForm() === 1) {
        try {
          this.datoMedioEmp.idEmpresa = window.sessionStorage.getItem('idEmpresa')
          await api.post('/medioemps', this.datoMedioEmp)
          $('#ventanaModal').modal('hide')
          swal('Correcto!', 'MedioEmp creada exitosamente!', 'success')
          this.getDataTodos()
        } catch (error) {
          swal('Error!', 'Intentelo de nuevo!', 'error')
        }
      }
    },

    async guardarEditMedioEmp() {
      if (this.validarForm() === 1) {
        try {
          await api.post('/medioemps', this.datoMedioEmp)
          $('#ventanaModal').modal('hide')
          this.getDataTodos()
          swal('Correcto!', 'MedioEmp actualizado(a) exitosamente!', 'success')
        } catch (error) {
          swal('Error!', 'Intentelo de nuevo!', 'error')
          const array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },

    abrirModalCrear() {
      this.modalWindow  = true
      this.datoMedioEmp = {}
      this.titulo       = 'Crear Empresa: Medios de Comunicación'
      this.btnCrear     = true
      this.btnEditar    = false
      this.$nextTick(() => $('#ventanaModal').modal('show'))
    },

    abrirModalEditar(idMedioEmp) {
      this.modalWindow = true
      if (idMedioEmp != null) {
        api.get('/vwmedioemps/' + idMedioEmp).then(resp => {
          this.datoMedioEmp = resp.data
        })
      }
      this.titulo    = 'Editar Empresa: Medios de Comunicación'
      this.btnCrear  = false
      this.btnEditar = true
      this.$nextTick(() => $('#ventanaModal').modal('show'))
    },

    async deleteMedioEmp(idMedioEmp) {
      try {
        await api.delete('/medioemps/' + idMedioEmp)
        this.getDataTodos()
      } catch (error) {
        alert('No se pudo eliminar')
      }
    },

fetchMedioComs() {
  api.get('/vwmediocoms')
    .then(r => { this.medioComs = r.data })
    .catch(e => console.error('Error fetching medioComs:', e))
},
  },
}
</script>